import { render, staticRenderFns } from "./CloseTask.vue?vue&type=template&id=374f0ce5&scoped=true"
import script from "./CloseTask.vue?vue&type=script&lang=js"
export * from "./CloseTask.vue?vue&type=script&lang=js"
import style0 from "./CloseTask.vue?vue&type=style&index=0&id=374f0ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f0ce5",
  null
  
)

export default component.exports